<mat-progress-bar [mode]="(saving$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>

<div mat-dialog-title>
  <h2>{{ 'dialog.authorization.title' | translate }}</h2>
</div>

<form
  fxLayout="column"
  fxLayoutGap="10px"
  [formGroup]="authForm"
>
  <mat-dialog-content class="p-0">
    <mat-tab-group #tabGroup>
      <mat-tab [label]="'patient-details.authorization-card.tabs.details' | translate">
        <div class="p-4">
          <mmx-auth-details-form
            formControlName="details"
            [includeUnits]="includeUnits"
            [outdated]="outdated"
            [ignoredOutdatedConflicts]="ignoredOutdatedConflicts"
            [outdatedWarnings]="outdatedWarnings"
            [diagnosisCodes]="diagnosisCodes$ | async"
            [suggestedProcedureCodes]="suggestedProcedureCodes$ | async"
            [appointment]="data.appointment"
            [timezone]="data.timezone"
            [patientInsurances]="data.patientInsurances"
            [manuallyEditedFields]="data.authorization?.manuallyEditedFields"
            [lockingField]="lockingField$ | async"
            (ignoreOutdatedConflicts)="ignoreOutdatedConflicts()"
            (pullStatusClicked)="onPullStatus()"
            (unlockField)="onUnlockField($event)"
            (lockField)="onLockField($event)"
          ></mmx-auth-details-form>

          <mmx-auth-status-details
            *ngIf="statusPullData"
            [statusPullData]="statusPullData"
          ></mmx-auth-status-details>
        </div>
      </mat-tab>

      <ng-container *appHasModule="'authorizationSubmission'">
        <mat-tab
          [label]="'patient-details.authorization-card.tabs.clinical-information' | translate"
          [disabled]="!data.authorization?.id || authForm.value.details.status === 'NR'"
        >
          <div class="p-4">
            <mmx-auth-clinical-information
              [questions]="questions$ | async"
              [availablePortals]="availablePortals"
              formControlName="clinicalInformation"
              [attachmentsLoading]="attachmentsLoading$ | async"
              [attachments]="attachments$ | async"
              (pendingAttachments)="onPendingAttachments($event)"
              (newAttachmentsAdded)="onNewAttachmentsAdded()"
            ></mmx-auth-clinical-information>
          </div>
        </mat-tab>

        <mat-tab
          *ngIf="data.authorization?.id && isAuthSubmissionSupported"
          [label]="'patient-details.authorization-card.tabs.submit' | translate"
        >
          <div
            *ngIf="insuranceProviderConfigurationService.configuration$ | async as configuration"
            fxLayout="column"
            class="px-4"
          >
            <form [formGroup]="submissionForm">
              <mmx-prior-authorization-form
                *ngIf="configuration"
                formControlName="priorAuthorization"
                [configuration]="configuration"
                [data]="formData"
              ></mmx-prior-authorization-form>
            </form>

            <div class="loading-form" *ngIf="insuranceProviderConfigurationService.isLoading$ | async">
              {{ 'common.loading' | translate }}
            </div>
          </div>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>
      {{ 'common.cancel' | translate }}
    </button>
    <span fxFlex></span>
    <span
      *ngIf="duplicateAuthorizationMessage$ | async as duplicateMessage"
      class="text-warn mr-6"
    >
      {{ duplicateMessage }}
    </span>
    <button
      *ngIf="statusPullData?.canPullStatus"
      mat-flat-button
      type="button"
      class="mr-2"
      [disabled]="saving$ | async"
      (click)="onPullStatus()"
    >
      {{ 'dialog.authorization.pull-pre-auth' | translate }}
    </button>

    <button
      *ngIf="tabGroup.selectedIndex !== 2; else submitToPayerButton"
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="saveButtonDisabled$ | async"
      (click)="onSubmit()"
    >
      {{ 'common.save' | translate }}
    </button>

    <ng-template #submitToPayerButton>
      <button
        mat-flat-button
        type="button"
        color="primary"
        [disabled]="submitToPayerDisabled$ | async"
        (click)="onSubmitToPayer()"
      >
        {{ 'patient-details.authorization-card.actions.submit-to-payer' | translate }}
      </button>
    </ng-template>
  </mat-dialog-actions>
</form>
